import FontSelector from '../../features/fontSelector/FontSelector';
import SolidColorSelector from '../../features/solidColorSelector/SolidColorSelector';
import useUpdateEffect from 'lib/reusable-components/hooks/useUpdateEffect';

import { defaultReportTools, defaultReportType } from '../../data/defaultSchema';
// ICONS
import { FiEdit3 } from 'react-icons/fi';
import { IoOptionsOutline } from 'react-icons/io5';
import { BsCheckLg } from 'react-icons/bs';
import { HiX } from 'react-icons/hi';
import { useEffect, useRef, useState } from 'react';
import { defaultChartWidthTypesObj } from 'lib/reusable-components/reusableData/defaultChartSchema';
import ObjectDropDown from 'lib/reusable-components/Components/DropDowns/ObjectDropDown';
import { FaFilter } from 'react-icons/fa';
import { getPlotData } from 'lib/reports-analytics/utils/dragableFunctions';
import { mls } from 'lib/multilanguagesupport';
import { chartCapableOfHavingInsights } from 'lib/reusable-components/reusableData/chartData';
interface ReportStyleProps {
  setTargetElem: Function;
  targetElem: any;
  show?: boolean;
  autoCloseOff?: boolean;
  inputToggleOpen?: boolean;
  setInputToggleOpen?: Function;
  isStyleDivOpen: boolean;
  setIsStyleDivOpen: Function;
  handleTopFilter?: Function;
  removeItem: Function;
  style: any;
  reportElemType: string;
  isOption?: boolean;
  stateProps: any;
}
export const ReportStyle = ({
  style,
  inputToggleOpen = false,
  setInputToggleOpen = () => {},
  isStyleDivOpen,
  setIsStyleDivOpen,
  handleTopFilter = () => {},
  targetElem,
  setTargetElem,
  removeItem,
  reportElemType,
  show = false,
  autoCloseOff = false,
  isOption = true,
  stateProps,
}: ReportStyleProps) => {
  const [isStyleDivContent, setIsStyleDivContent] = useState(show);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const handleInputToggle = () => {
    setInputToggleOpen(!inputToggleOpen);
  };
  const handleStyle = (udpdatedStyle: React.ChangeEvent<HTMLInputElement>) => {
    setTargetElem({ ...targetElem, style: udpdatedStyle });
  };

  useEffect(() => {
    if (isStyleDivOpen) {
      setIsStyleDivContent(isStyleDivOpen);
    } else {
      setTimeout(() => {
        setIsStyleDivContent(isStyleDivOpen);
      }, 300);
    }
  }, [isStyleDivOpen]);

  const handleToggleStyle = () => {
    setIsStyleDivOpen((currentData: boolean) => !currentData);
  };
  useUpdateEffect(() => {
    if (autoCloseOff) {
      return;
    }
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // onClose && onClose();
        setTimeout(() => setIsStyleDivOpen(false), 10);
      }
    }

    if (isStyleDivOpen) {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef, isStyleDivOpen]);

  return (
    <div className={isStyleDivOpen ? 'reportStyle hovered' : 'reportStyle'}>
      {reportElemType === defaultReportTools.inputText.reportToolType ? (
        <div
          className='editTextOptionButton optionButton primaryButton'
          onClick={() => handleInputToggle()}
        >
          <div className='optionButtonIcon'>{inputToggleOpen ? <BsCheckLg /> : <FiEdit3 />}</div>
        </div>
      ) : null}
      {reportElemType === defaultReportType.charts ||
      reportElemType === defaultReportType.insights ? (
        <div
          className='editTextOptionButton optionButton primaryButton'
          onClick={() => handleTopFilter(true)}
        >
          <div className='optionButtonIcon'>
            <FaFilter />
          </div>
        </div>
      ) : null}
      {isOption ? (
        <div className='styleOptionButton optionButton primaryButton ' ref={wrapperRef}>
          <div className='optionButtonIcon' onClick={() => handleToggleStyle()}>
            <IoOptionsOutline />
          </div>

          {/* Style Option */}
          <div className={isStyleDivOpen ? 'editReportStyleOption open' : 'editReportStyleOption'}>
            {isStyleDivContent ? (
              <>
                {reportElemType === defaultReportTools.inputText.reportToolType ? (
                  <TextToolStyle elem={style} handleStyle={handleStyle} />
                ) : null}
                {reportElemType === defaultReportTools.line.reportToolType ? (
                  <LineToolStyle elem={style} handleStyle={handleStyle} />
                ) : null}
                {reportElemType === defaultReportType.charts ? (
                  <ChartStyle
                    elem={style}
                    handleStyle={handleStyle}
                    setTargetElem={setTargetElem}
                    handleTopFilter={handleTopFilter}
                    targetElem={targetElem}
                    stateProps={stateProps}
                  />
                ) : null}
                {reportElemType === defaultReportType.insights ? (
                  <ChartStyle
                    elem={style}
                    handleStyle={handleStyle}
                    setTargetElem={setTargetElem}
                    handleTopFilter={handleTopFilter}
                    targetElem={targetElem}
                    stateProps={stateProps}
                  />
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      ) : null}
      <div
        className='editTextOptionButton optionButton primaryButton removeButton'
        onClick={() => removeItem()}
      >
        <div className='optionButtonIcon'>
          <HiX />
        </div>
      </div>
    </div>
  );
};
interface TextToolStylePropsp {
  elem: any;
  handleStyle: Function;
}

const LineToolStyle = ({ elem, handleStyle }: TextToolStylePropsp) => {
  return (
    <>
      <SolidColorSelector color={elem} setColor={handleStyle} />
    </>
  );
};
const TextToolStyle = ({ elem, handleStyle }: TextToolStylePropsp) => {
  return (
    <>
      <FontSelector fontStyle={elem} setFontStyle={handleStyle} />
      <SolidColorSelector color={elem} setColor={handleStyle} />
    </>
  );
};

interface ChartStylePropp {
  elem: any;
  setTargetElem: Function;
  handleStyle: Function;
  handleTopFilter: Function;
  targetElem: any;
  stateProps: any;
}
const ChartStyle = ({
  elem,
  targetElem,
  handleStyle,
  setTargetElem,
  handleTopFilter,
  stateProps,
}: ChartStylePropp) => {
  const { reportFilter } = stateProps;
  const updateChartWidth = (action: string) => {
    handleStyle({ ...elem, chartWidth: action });
  };
  const { reportTimeFrame, chartsData, tableDataInSheetID } = stateProps;
  const tableSchema = tableDataInSheetID[targetElem?.sheetID] ?? {};
  const chartSchema = chartsData[targetElem.chartID];
  const updateType = async (action: string) => {
    const plotDataProps = {
      tableSchema,
      reportTimeFrame,
      chartSchema: { ...chartSchema, filters: targetElem?.chartFilter },
      type: action,
      filters: reportFilter,
    };
    const plotDataRes = await getPlotData(plotDataProps);
    if (plotDataRes.skip) {
      return;
    }
    setTargetElem({ ...targetElem, type: action, plotData: plotDataRes.plotData });
  };
  const isInsightsCapable = chartCapableOfHavingInsights.some(
    (elem) => chartSchema?.chartType === elem
  );
  return (
    <>
      <div className='reportStyleInnerItem'>
        <div className='titleDiv'>{mls('Chart/Insights')}</div>
        <div className='chartInsightSelector'>
          <div className='chartInsightOption' onClick={() => updateType(defaultReportType.charts)}>
            <input
              type='radio'
              checked={targetElem.type === defaultReportType.charts}
              name={defaultReportType.charts}
            />
            {mls('Chart')}
          </div>
          {isInsightsCapable ? (
            <div
              className='chartInsightOption'
              onClick={() => updateType(defaultReportType.insights)}
            >
              <input
                type='radio'
                checked={targetElem.type === defaultReportType.insights}
                name={defaultReportType.insights}
              />
              {mls('Insights')}
            </div>
          ) : null}
        </div>
        {targetElem.type === defaultReportType.insights ? (
          <></>
        ) : (
          <>
            <div className='titleDiv'>{mls('Chart Width')}</div>
            <div className='chartWidthDropDown'>
              <ObjectDropDown
                object={defaultChartWidthTypesObj}
                dropDownValue={elem?.chartWidth}
                setdropDownValue={updateChartWidth}
                ObjectInObject
              />
            </div>
          </>
        )}

        <div className='titleDiv'>{mls('Chart Filter')}</div>
        <button
          className='primaryButton secondaryButtonColor '
          style={{ width: ' 100%' }}
          onClick={() => handleTopFilter(true)}
        >
          {mls('Open Filter')}
        </button>
      </div>
      <br />
      <br />
      <br />
      {/* <SolidColorSelector color={elem} setColor={handleStyle} /> */}
    </>
  );
};
